import React from 'react';
import 'dayjs/locale/es';
import { DatesProvider, DatePickerInput as MantineDateInput } from '@mantine/dates';
import dayjs from 'dayjs';

const CustomDateInput = (props) => {
  // Función para forzar la interpretación como DD/MM/YYYY
  const dateParser = (input) => {
    const parsedDate = dayjs(input, 'DD/MM/YYYY', true); // Asegura que siga este formato
    return parsedDate.isValid() ? parsedDate.toDate() : null; 
  };

  return (
    <DatesProvider settings={{ locale: 'es', firstDayOfWeek: 0, weekendDays: [0], timezone: 'UTC' }}>
      <MantineDateInput
        {...props}
        //dateParser={dateParser} 
        valueFormat="DD/MM/YYYY" 
      />
    </DatesProvider>
  );
};

export default CustomDateInput;
